import ContentLayout from "@/modules/merchant/layout/contentLayout";
import PeopleIcon from "@mui/icons-material/People";
import Content from "./content";
/**
 * DetailPages
 *
 * صفحه جزئیات مربوط به خدمات مشتریان.
 * این کامپوننت از ContentLayout برای ساختار کلی صفحه استفاده می‌کند و آیکون و عنوان صفحه را تنظیم می‌کند.
 * همچنین محتوای اصلی صفحه را از کامپوننت Content بارگذاری می‌کند.
 *
 * - icon: آیکون نمایش داده شده در هدر صفحه (PeopleIcon)
 * - title: عنوان صفحه ("خدمات مشتریان")
 * - isContainerFluid: تعیین حالت کشسانی کانتینر صفحه
 *
 * @returns JSX.Element
 */

const DetailPages = () => {
  return (
    <ContentLayout icon={<PeopleIcon />} title="خدمات مشتریان" isContainerFluid>
      <Content />
    </ContentLayout>
  );
};

export default DetailPages;
